(() => {
  const market = document.querySelector('[data-alveroa-market]');
  if (market) {
    const form = market.querySelector('form');
    const select = form && form.querySelector('[name="country_code"]');
    const key = 'alveroa-country:' + location.hostname;
    const retryKey = key + ':default-attempted';
    let explicitCountry = '';
    let attempted = false;
    try {
      explicitCountry = localStorage.getItem(key) || '';
      attempted = sessionStorage.getItem(retryKey) === '1';
    } catch (_) {}
    if (form && select) {
      form.addEventListener('submit', () => {
        try { localStorage.setItem(key, select.value); } catch (_) {}
      });
      const target = market.dataset.domainDefault;
      const mismatch = target && market.dataset.expectedCurrency !== market.dataset.currency;
      if (mismatch && !explicitCountry && !attempted && !market.hasAttribute('data-design-mode')) {
        const available = Array.from(select.options).some(option => option.value === target);
        if (available) {
          select.value = target;
          let safeToSubmit = false;
          try { sessionStorage.setItem(retryKey, '1'); safeToSubmit = true; } catch (_) {}
          if (safeToSubmit) form.submit();
        }
      }
    }
  }
  document.querySelectorAll('[data-alveroa-captions]').forEach(video => {
    const showCaptions = () => {
      if (video.textTracks.length) video.textTracks[0].mode = 'showing';
    };
    video.addEventListener('loadedmetadata', showCaptions, {once: true});
    showCaptions();
  });
  const newsletter = document.querySelector('#ContactFooter');
  if (newsletter) {
    const consent = newsletter.querySelector('#check_newsletter');
    const email = newsletter.querySelector('input[type="email"]');
    const submit = newsletter.querySelector('button[type="submit"]');
    if (email) email.required = true;
    if (consent && submit) {
      consent.required = true;
      const update = () => { submit.disabled = !consent.checked; };
      consent.addEventListener('change', update);
      update();
    }
  }
})();
